'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _CodeEditor = require('../CodeEditor');

var _CodeEditor2 = _interopRequireDefault(_CodeEditor);

var _FieldList = require('../FieldList');

var _FieldList2 = _interopRequireDefault(_FieldList);

var _util = require('./util');

var _JsonSchema = require('../JsonSchema');

var _JsonSchema2 = _interopRequireDefault(_JsonSchema);

var _Panel = require('../Panel');

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
var MethodParameters = function (_React$Component) {
	_inherits(MethodParameters, _React$Component);

	function MethodParameters(props) {
		_classCallCheck(this, MethodParameters);

		var _this = _possibleConstructorReturn(this, (MethodParameters.__proto__ || Object.getPrototypeOf(MethodParameters)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(MethodParameters, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    verb = _props.verb,
			    path = _props.path,
			    doc = _props.doc,
			    pIn = _props.in,
			    hasExample = _props.hasExample;

			var renderParams = void 0;
			// get parameters for verb merged with global parameters defined on the path
			var parameters = (0, _util.getParametersForMethod)(doc, path, verb, pIn);

			if (!parameters || !parameters.length) {
				return null;
			}

			if (parameters.length === 1 && parameters[0].in === 'body') {
				var param = parameters[0];
				param = (0, _util.deref)(doc, param.schema);

				// Filter out the readOnly params.
				if (param.properties) {
					param.properties = Object.keys(param.properties).filter(function (p) {
						return !param.properties[p].readOnly;
					}).reduce(function (col, cur) {
						col[cur] = param.properties[cur];
						return col;
					}, {});
				}

				if (hasExample) {
					var body = JSON.stringify((0, _util.getDefaultsFromJSONSchema)(param), null, 2);
					renderParams = _react2.default.createElement(
						_reactBootstrap.Accordion,
						null,
						_react2.default.createElement(
							_Panel2.default,
							{
								independent: true,
								hasIcon: true,
								defaultExpanded: false,
								bsStyle: 'default',
								bsSize: 'small',
								header: parameters[0].name,
								animate: false,
								borders: false,
								className: 'schema'
							},
							_react2.default.createElement(
								_reactBootstrap.FormGroup,
								{ key: 'body', controlId: 'frm_body' },
								_react2.default.createElement(
									_reactBootstrap.Tabs,
									{ animation: false, className: 'axui', id: 'tabs-' + verb + '-' + path.slice(1) + '-' + parameters[0].name },
									_react2.default.createElement(
										_reactBootstrap.Tab,
										{ eventKey: 1, title: 'Schema' },
										_react2.default.createElement(_JsonSchema2.default, { schema: param })
									),
									_react2.default.createElement(
										_reactBootstrap.Tab,
										{ eventKey: 2, title: 'Example' },
										_react2.default.createElement(_CodeEditor2.default, {
											code: body,
											mode: 'json',
											lint: true,
											readOnly: true
										})
									)
								)
							)
						)
					);
				} else {
					renderParams = _react2.default.createElement(
						'div',
						{ className: 'schema' },
						_react2.default.createElement(_JsonSchema2.default, {
							title: parameters[0].name,
							expandable: true,
							expanded: false,
							schema: param
						})
					);
				}
			} else {
				var fields = [];
				parameters.filter(function (p) {
					return !p.readOnly;
				}).forEach(function (param) {

					if (param.name === 'Accept') {
						param.description = _this2.intl.formatMsg('The MIME types that are acceptable for the response.');
					} else if (param.name === 'Content-Type') {
						param.description = _this2.intl.formatMsg('The MIME type of the request body.');
					}

					var enumValues = param.enum || (param.items ? param.items.enum : undefined);

					fields.push(_react2.default.createElement(_FieldList2.default.Field, {
						key: param.name + param.type + param.in,
						name: param.name,
						type: param.type,
						description: param.description,
						'default': JSON.stringify(param.default),
						required: param.required,
						'enum': enumValues && enumValues.length && enumValues.map(JSON.stringify),
						maximum: param.maximum,
						exclusiveMaximum: param.exclusiveMaximum,
						minimum: param.minimum,
						exclusiveMinimum: param.exclusiveMinimum,
						maxLength: param.maxLength,
						minLength: param.minLength
					}));
				});
				renderParams = _react2.default.createElement(
					_FieldList2.default,
					{ striped: true },
					fields
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'ux-container' },
				_react2.default.createElement(
					'h4',
					null,
					this.props.heading
				),
				_react2.default.createElement(
					'div',
					{ className: 'parameters-container' },
					renderParams
				)
			);
		}
	}]);

	return MethodParameters;
}(_react2.default.Component);

MethodParameters.propTypes = {
	/**
  * Type of parameter heading
  */
	heading: _propTypes2.default.string.isRequired,

	/*
  * The path containing the parmeters to display
  */
	path: _propTypes2.default.string.isRequired,

	/*
  * The verb containing the parameters to display
  */
	verb: _propTypes2.default.string.isRequired,

	/*
  * Optional string or array of strings to filter the displayed parameters
  */
	in: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),

	/**
  * Valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired,

	/**
  * Specify if there is example body object
  */
	hasExample: _propTypes2.default.bool
};

MethodParameters.defaultProps = {
	hasExample: false
};

var _default = (0, _reactIntl.injectIntl)(MethodParameters);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(MethodParameters, 'MethodParameters', 'src/components/SwaggerUI/MethodParameters.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/MethodParameters.jsx');
}();

;